module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_7_3.b975b52c.png";